export const PROTIPS = [
  {
    id: "form-prompt",
    content:
      "Brainstorm can make lists of anything! Like features for an app, headlines for an article, or plot points in a mystery thriller.",
    button: "Gotcha",
    handPoints: "right",
    left: "-265",
    top: "84",
  },
  {
    id: "form-context",
    content:
      "Put extra info here — like important plot points, where (or when) the story takes place, the genre, or even whether you want funny or serious ideas!",
    button: "Haha, I knew that",
    handPoints: "right",
    left: "-265",
    top: "171",
  },
  {
    id: "form-starters",
    content: `Varying your starting examples is important. 
<br /><br />
“Using Glee<strong>berry</strong>” and “Floo<strong>berry</strong>” as examples would likely result in Brainstorm giving you words ending in “berry”. Adding “Flee<strong>blurp</strong>” (for example) would mix it up.`,
    button: "OK-berry",
    handPoints: "left",
    left: "685",
    top: "171",
  },
  {
    id: "list-voting",
    content: `Vote THUMBS_UP or THUMBS_DOWN on cards to get new ones.`,
    button: "THUMBS_UP",
    handPoints: "left",
    left: "480",
    top: "65",
  },
  {
    id: "list-reject",
    content: `Click THUMBS_DOWN when you dislike an idea and we’ll give you fewer ideas like it.`,
    button: "Got it",
    handPoints: "up",
    left: "20",
    top: "188",
  },
  {
    id: "start-over-tip",
    content: `You're in a new brainstorm now. Your old one was saved to a card.`,
    button: "THUMBS_UP",
    handPoints: "none",
    left: "5",
    top: "188",
  },
];

export const EXAMPLES2 = [
  {
    id: "dialogue-head-chef",
    category: "Dialogue",
    prompt:
      "Things a head chef would tell his team to fire them up before an international dumpling competition.",
    context: "The head chef has a strict leadership, but has a soft side",
    starters: [
      "You guys have worked so hard for this moment, so I just want us to go out there and have fun, alright?",
      "Let's remember why we're here. Forget about the competition. Let's focus on making the best damn dumplings you've ever tasted.",
    ],
  },
  {
    id: "dialogue-young-cop",
    category: "Dialogue",
    prompt:
      "Things a young cop in Atlanta would say to her friend while venting about a long day",
    context:
      "The story has a serious tone, but the character has a soft side and is not immune to the stresses of police work",
    starters: [
      '"Man, that was a long day"',
      '"You ever feel like it\'s exhausting just being alive?"',
    ],
  },
  {
    id: "dialogue-love-scene",
    category: "Dialogue",
    prompt:
      "Believable lines of dialogue for the beginning of a passionate love scene",
    context:
      "The two characters are coworkers who have worked together for a long time but were ashamed to admit they were attracted to one another.",
    starters: [
      '"I\'ve been waiting for this for so long"',
      '"Will you just kiss me already?"',
      '"Let\'s get this over with"',
    ],
  },
  {
    id: "dialogue-dying-friend",
    category: "Dialogue",
    prompt:
      "Believable lines of dialogue for a character whose friend is dying in his arms.",
    context:
      'This story takes place in Germany during World War 2.',
    starters: [
      '"C\'mon man. Don\'t look at me like that."',
      '"Keep breathing. Keep breating. Keep breating."',
    ],
  },
  {
    id: "dialogue-retired-postman",
    category: "Dialogue",
    prompt:
      "Something a retired postman would say to his wife when his team loses in the superbowl.",
    context: "His team is the Packers, and it was a really close game.",
    starters: ['"Why do I subject myself to this torture?"', '"This referee couldn\'t tell his ass from his elbow"'],
  },
  {
    id: "characters-lottery-love",
    category: "Characters",
    prompt: "Love interests for a protagonist who's just won the lottery",
    context: "In a short story that takes place in Boston",
    starters: [
      "The cashier at the gas station where the protagonist bought the ticket",
      "The bank teller who is there when the protagonist makes the deposit",
    ],
  },
  {
    id: "character-mentor-death-ways",
    category: "Characters",
    prompt: "Ways for a mentor to die",
    context:
      "In a novel about a woman who gains magic powers from a chance encounter with a monk in Argentina.",
    starters: [
      "The Sharga: A group of nomads who live on giant spiders, masquerade as asylum-seekers and stab the mentor",
      "The mentor sacrifices himself to save a loved one of the main character",
    ],
  },
  {
    id: "character-obstacles",
    category: "Characters",
    prompt:
      "Personal obstacles that an 18-year-old faces that prevents them from reaching their goal",
    context: "In a drama screenplay",
    starters: [
      "The parents of his boyfriend find out about their relationship and forbid them from seeing each other.",
      "He can't choose which college to apply to.",
      "He gets cut from the cross-country team, jeopardizing his scholarship.",
    ],
  },
  {
    id: "character-past-events",
    category: "Characters",
    prompt: "Events in Julie's past that caused her to develop a cold heart",
    context:
      "Julie is a shrewd businesswoman working on Wall Street but has a soft side",
    starters: [
      "Her parents seemed to favor her younger sister and she decided not to care what other people think.",
      "Her ex was the breadwinner and abused that power, so now Julie wants to be independent.",
    ],
  },
  {
    id: "world-building-spaceship-names",
    category: "world-building",
    prompt: "Names and descriptions of spaceships",
    context: "Think distant future science fiction novel set in another galaxy",
    starters: ["Red Dwarf: Manned by a faction of asteroid miners who bootleg their own spice. ", "Mobius Express: A hypership that fluctuates between two sides of a thread of spacetime while its occupants search for life among the stars", "Peace Keeper: Shaped like a donut with a prison in the center, crewed by people trying to escape"],
  },
  {
    id: "world-building-potions",
    category: "world-building",
    prompt: "Potions, their ingredients, recipe, and effect",
    context: "YA fae fantasy",
    starters: [
      "The Glow-worm's Eye Potion: Brewed from the crushed remains of a glow-worm and a red mold from the basement of a church, it paints a glow on the drinker's eyes and makes him appear more attractive to the opposite sex.",
      "The Where-upon's Almanac: Brewed from a marmalade toad, a horologium and a violet upon which to focus the powder of a mandrake root, it enables the drinker the gift of foresight in his calculations.",
    ],
  },
  {
    id: "world-building-cultures",
    category: "world-building",
    prompt: "Backgrounds for believable cultures",
    context: "In a fantasy novel",
    starters: [
      "The Rishans: A group of wizards who are interested in advancing science, rather than in magic",
      "The Fauns: A small, furry people who live in the forest",
      "The Sharga: A group of nomads who ride giant spiders",
    ],
  },
  {
    id: "world-building-ecosystem",
    category: "world-building",
    prompt: "Ways for an ecosystem to be destroyed",
    context: "In a climate fiction short story",
    starters: [
      "Deforestation and loss of plant life",
      "Fertilizer run-off from lawns and farms",
      "Overgrazing by livestock",
    ],
  },
  {
    id: "world-building-cultural-tension",
    category: "world-building",
    prompt: "Reasons for geopolitical tension between two cultures",
    context: "The story takes place in a steampunk speculative fiction novel",
    starters: [
      "One culture has control of all the Iridium - a metal needed for steampunk technology",
      "A border dispute left three citizens on both sides dead - neither side is willing to take blame",
    ],
  },
  {
    id: "plot-points-protagonist-villain",
    category: "plot-points",
    prompt: "Ways a protagonist and villain could interact",
    context: "An adventure quest novel series",
    starters: [
      "The villain visits and threatens the protagonist in their dreams",
      "The protagonist sends scouts to find and observe the location of the villain's castle",
    ],
  },
  {
    id: "plot-points-grow-change",
    category: "plot-points",
    prompt: "Ways for good characters to grow and change",
    context: "An intriguing, passionate coming-of-age tale",
    starters: [
      "They're building a house that represents their own personal growth",
      "The main character starts going to a therapist and uncovers truths about themselves",
    ],
  },
  {
    id: "plot-points-seance-horror-film",
    category: "plot-points",
    prompt: "Ways to foreshadow later events",
    context: "A horror film involving a seance",
    starters: [
      'One of the kids starts saying "Something bad\'s gonna happen to me."',
      "The electricity goes out whenever anyone talks about the Ouija board",
    ],
  },
  {
    id: "plot-points-detective-love",
    category: "plot-points",
    prompt:
      "Ways an antihero protagonist and another main character could fall in love",
    context: "In a gritty detective noir set in the 1940s",
    starters: [
      "The detective finds a piece of yarn and traces it back to a woman who gradually unraveled her sweater",
      "They leave each other increasingly specific clues until they finally meet at a diner for coffee.",
    ],
  },
  {
    id: "plot-points-detective-love",
    category: "plot-points",
    prompt:
      "Ways to get the heroes together for the climactic final fight scene",
    context: "A team superhero movie",
    starters: [
      "One character creates portals around the world and collects the other superheroes",
      "All the superheroes are enlisted by the government to solve an existential crisis",
    ],
  },
  {
    id: "plot-points-detective-love",
    category: "plot-points",
    prompt: "Ways Stephanie's airhead boyfriend could grow a backbone",
    context: "A teen romance novel",
    starters: [
      "He loses a fight and decides to join a dojo",
      "He becomes the mentor for another character's younger brother who's being bullied",
    ],
  },
  {
    id: "names-butler",
    category: "Names",
    prompt: "Names for a butler",
    context: "In a science fiction movie",
    starters: ["Chauncey-009", "Giorgio"],
  },
  {
    id: "names-dwarf-barbarian",
    category: "Names",
    prompt: "Names for a dwarf barbarian who wanders the wasteland",
    context: "Serious tone, epic fantasy",
    starters: ["Goriax", "Dorgon the Black"],
  },
  {
    id: "names-island-warriors",
    category: "Names",
    prompt: "Names for an island nation inhabited by warriors",
    context: "Fantasy film set in Europe",
    starters: ["Spartaria", "Isle of Dagger"],
  },
  {
    id: "names-robot-depression",
    category: "Names",
    prompt: "Names for a robot with severe depression",
    context: "In a science fiction short story",
    starters: ["Melancholia", "Sufferbot"],
  },
  {
    id: "names-minnesota-woman",
    category: "Names",
    prompt: "Names for a middle-aged woman living in Minnesota",
    context: "She is the boss of the main character in my story",
    starters: ["Samantha Johns", "Caroline Roche", "Mary DeVecchis"],
  },
  {
    id: "places-diners",
    category: "Places",
    prompt: "A neighborhood diner where the protagonist likes to hang out",
    context: "Located in Poughkeepsie, New York, in the 1960's",
    starters: [
      "Luciano's Diner - A greasy spoon built inside an old railroad car. It specializes in bagels and is open 24 hours. The proprietor hires local high school kids as waiters and waitresses.",
      "Jim's - Short for Jim's Diner, has been around for 50 years. The seats are made of tacky orange vinyl and the thick linoleum-covered tables have the initials of patrons carved into their wooden edges. Best flapjacks in the tri-state area.",
    ],
  },
  {
    id: "places-campsite",
    category: "Places",
    prompt: "A campsite where someone went missing last week",
    context: "This is a magical realism / mystery short story",
    starters: ["Whistler's Peak", "Lake Louise"],
  },
  {
    id: "places-wizard",
    category: "Places",
    prompt: "Places an evil wizard and her dragon might choose as a lair",
    context: "Magical fantasy story that takes place primarily in the forest",
    starters: [
      "A cave behind a waterfall which glows at night. The wizard's spell keeps the water from seeping into the cave, and the dragon's fire keeps their home warm.",
      "In the middle of a large rotting tree in a swamp",
    ],
  },
  {
    id: "places-battlefield",
    category: "Places",
    prompt: "A place where an epic battle occurred 1,000 years ago",
    context: "Science fiction story that takes place in outer space",
    starters: [
      "The wastes - an asteroid belt that used to host a vibrant society",
      "The opening - a black hole that consumed a multiverse after an epic space battle concluding in a massive explosion",
    ],
  },
  {
    id: "places-saloon",
    category: "Places",
    prompt: "A saloon in Arizona where the main character stops in for a drink",
    context: "This is a western set in the 1880s",
    starters: ["The Squeaky Wheel features a water trough for your horse out front and a wide selection of local moonshine, some of which will almost certainly make you go blind, in the back. A thick layer of dust covers every surface.", "The Whistler, a run down spot with a sheriff asleep on the porch. A young boy plays piano on the inside, but he doesn't go very long in between mistakes."],
  },
  {
    id: "objects-cyberpunk-tools",
    category: "Objects",
    prompt:
      "Tools a cyberpunk hacker uses to break into a megacorporation.",
    context:
      "Setting is a dark world with sophisticated miniature robotics, and a small cabal of elites rule with corporate power.",
    starters: [
      "Hackbots - microscopic robots that can burrow into electronics and reprogram them",
      "Viroid - a cryptographic disk that can be inserted into a computer to corrupt its memory",
    ],
  },
  {
    id: "objects-soldier-carries",
    category: "Objects",
    prompt: "Things a soldier carries around with him",
    context: "Takes place in World War 1. The protagonist is American",
    starters: [
      "A railroad nail he took from the tracks near his house",
      "A flask to carry some whiskey in",
    ],
  },
  {
    id: "objects-princess-flees",
    category: "Objects",
    prompt:
      "Possessions a princess brings with her when she flees the castle to live with an evil warlock",
    context:
      "The princess is a bit of a tomboy, and there's no magic in this world (yet)",
    starters: [
      "Her favorite fishing hooks",
      "A knife she uses to carve little statues",
    ],
  },
  {
    id: "objects-dealer-desk",
    category: "Objects",
    prompt:
      "Little bits and bobs a Hong Kong casino dealer has on their desk at home",
    context:
      "The dealer is an aspiring writer who thinks up story plots dealing cards at the casino",
    starters: [
      "A pile of crumpled beginnings of stories",
      "A typewriter collecting dust",
    ],
  },
  {
    id: "objects-suspect-items",
    category: "Objects",
    prompt:
      "Suspicious items at the murder suspect's house that hint something is off",
    context:
      "He poisoned his victim's tap water.",
    starters: [
      "A assortment of 5-6 old phones in the corner of the living room",
      "3 large bottles of bleach in the kitchen",
    ],
  },
  {
    id: "descriptions-dealer-car",
    category: "Descriptions",
    prompt: "Descriptions of the interior of a drug dealer's car",
    context: "It's an old '72 Camaro",
    starters: [
      "An worn pine tree scent diffuser dangles from the rear-view mirror",
      "A crusty pile of coins and cheeto detritus lingers in the cupholders",
    ],
  },
  {
    id: "descriptions-widow-piano",
    category: "Descriptions",
    prompt: "Details about the piano in the house of a once-wealthy widow.",
    context: "She lives alone in a crumbling mansion in Connecticut",
    starters: [
      "The paint on the middle C and nearby keys has is worn off, revealing that the keys are cheap pine",
      "A thin layer of dust has started to form everywhere except the sheet music, which she shuffles around occasionally",
    ],
  },
  {
    id: "descriptions-ramen-shop",
    category: "Descriptions",
    prompt:
      "A sensory detail about the ramen a supernatural detective eats after successfully capturing a ghost that was terrorizing a small family",
    context: "The detective is a thin woman from Hokkaido",
    starters: [
      "The ramen's chashu pork was surprisingly thick and crunchy",
      "The bone broth was thick and warm, just what she needed.",
    ],
  },
  {
    id: "descriptions-cyberpunk-city",
    category: "Descriptions",
    prompt:
      "A detail about what the main character sees while roaming the streets of a cyberpunk desert city after getting off the plane",
    context: "The character is looking for a place to eat",
    starters: [
      "A children's toy store, with cars, dolls, and other trinkets suspended in plastic packaging, stacked all the way to the ceiling",
      "A tall brick building with elaborate geometric pattern windows of various shapes looping around the facade.",
    ],
  },
  {
    id: "descriptions-aristocrat-dress",
    category: "Descriptions",
    prompt:
      "Details on the dress of an aristocrat at a royal ball in the 1600s",
    context:
      "The main character is a tailor so he will notice minute details on the garment",
    starters: [
      "The seams around the shoulders and neckline were done impeccably well, firm yet delicate",
      "The button holding the back of the dress together is a simple pearl clasp that blends into the lace surrounding it.",
    ],
  },
  {
    id: "article-ideas-baking-blog",
    category: "article-ideas",
    prompt: "Articles for a baking blog",
    context:
      "We sell artisan unbleached flour and a variety of cooking utensils",
    starters: [
      "What would happen if you tried to bake on Mars? We interviewed a physicist to find out.",
      "You won't believe what we found when we looked at our flour under a microscope",
    ],
  },
  {
    id: "article-ideas-newsletter-writers",
    category: "article-ideas",
    prompt: "Topics for a newsletter about helping writers market their work",
    context: "list-based creative writer marketing newsletter",
    starters: [
      "10 writer tiktoks you should be paying attention to",
      "5 ways to help your fans spread your work",
    ],
  },
  {
    id: "article-ideas-romance-blog",
    category: "article-ideas",
    prompt: "Articles for a blog about being a romance writer",
    context: "Inspirational and creative",
    starters: [
      "Say what? 10 ways to spice up your dialogue",
      "Try these 7 steamy strategies to start your love scene",
    ],
  },
  {
    id: "article-ideas-lifestyle-blog",
    category: "article-ideas",
    prompt: "Articles for a lifestyle blogger",
    context:
      "Focuses on cooking ideas for people with limited time and budgets",
    starters: [
      "10 air fryer hacks for lazy chefs",
      "My wife cried when I gave her these brownies",
    ],
  },
  {
    id: "article-ideas-luxury-watches",
    category: "article-ideas",
    prompt: "Articles for a company selling luxury watches",
    context:
      "Focuses on providing useful knowledge that is hard to find elsewhere",
    starters: [
      "Real or Fake? 10 things to look for on eBay to spot a fake",
      "Why is Rolex increasing in value this year? I'll tell you the secret",
    ],
  },

  {
    id: "tweets-startup-lessons",
    category: "Tweets",
    prompt: "Tweets about lessons learned from working at a startup",
    context:
      "I have an audience of mostly designers and developers working at startups",
    starters: [
      "A sign of product market fit is if you are terrified of your AWS bill",
      "Your users are the greatest learning resource you have. Listen to them!",
    ],
  },
  {
    id: "tweets-hard-to-start",
    category: "Tweets",
    prompt: "Tips for writers who are having a hard time starting",
    context: "I'm mostly thinking of romance authors",
    starters: [
      "A good story always starts with memorable characters. Instead of trying to start a novel, just think of it as getting to know a character",
      "Give yourself thirty minutes to write a story with only 200 unique words. You'll be surprised at how good the result is",
    ],
  },
  {
    id: "tweets-relatable-new-york",
    category: "Tweets",
    prompt: "Tweets about relatable New York experiences",
    context:
      "Funny and revealing of the emotional, Machiavellian nature of New York",
    starters: [
      "one fun thing about living in New York now as opposed to when I was 20 is I can afford AC",
      "Walking in bushwick and someone's angry spouse just threw this mac out the window, killing a pigeon on the way down",
      "My favorite Baby Bjorn accessory is the hot dog holder",
    ],
  },
  {
    id: "tweets-philosophical-advice",
    category: "Tweets",
    prompt: "Tweets giving philosophical life advice",
    context: "Mix of funny and reflective",
    starters: [
      "99% of learning happens after school",
      "To learn something, make it painful to not learn",
    ],
  },
  {
    id: "tweets-short-job-advice",
    category: "Tweets",
    prompt: "Short pieces of advice for job-seekers",
    context: "Mostly helping early career people in interviews",
    starters: [
      "When talking about your work experiences, focus on the narrative of how you overcame challenges, instead of the nitty gritty details of the project",
      "Don't blame others for problems at your prior jobs, this signals you're likely to play the blame game at this job, too",
    ],
  },
];
